import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function AuthoritySection() {
  return <section className="py-16 bg-brand-dark text-white px-4 relative overflow-hidden" data-id="element-13">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-14"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-15">
        <ShieldCheck className="w-16 h-16 text-brand-yellow mx-auto mb-6" data-id="element-16" />

        <h2 className="text-2xl md:text-4xl font-bold leading-tight mb-8" data-id="element-17">
          No es solo un tutorial de n8n. <br data-id="element-18" />
          <span className="text-brand-yellow" data-id="element-19">
            Es un manual de operaciones de negocio.
          </span>
        </h2>

        <p className="text-xl md:text-2xl text-gray-300 font-medium max-w-3xl mx-auto leading-relaxed" data-id="element-20">
          Aprenderás la herramienta técnica, pero sobre todo, aprenderás a{' '}
          <span className="text-white font-bold border-b-2 border-brand-red pb-1" data-id="element-21">
            vender libertad operativa
          </span>{' '}
          a tus clientes.
        </p>
      </div>
    </section>;
}